import React, { useEffect, useState } from 'react';
import { DialogUI, InputUI } from '../../../Interface';
import { Box, Typography } from '@mui/material';
import dayjs from 'dayjs';
import projectTaskResourcePlannerService from '../../../../service/client/caravan/projectTaskResourcePlanner.service';

const SearchDialog = ({ open, handleClose, searchQuery, getTaskById, onSearchChange }) => {
  const [searchResults, setSearchResults] = useState([]);

  const getDialogTasks = () => {
    if (!searchQuery) {
      setSearchResults([]);
      return;
    }

    projectTaskResourcePlannerService.searchTasks({ query: searchQuery }).then((data) => {
      setSearchResults(data || []);
    });
  };

  useEffect(() => {
    getDialogTasks();
  }, [searchQuery]);

  return (
    <DialogUI
      open={open}
      onClose={handleClose}
      headerContent={'Találatok'}
      sx={{
        '& .MuiDialog-container': { alignItems: 'flex-start' },
        '& .MuiPaper-root': { width: '100%', maxWidth: '800px', height: '70vh' },
        '& .MuiDialogContent-root': { overflowY: 'auto', maxHeight: '100%' },
        marginTop: '40px',
      }}
    >
      <Box my={2}>
        <InputUI
          type="search"
          placeholder="Keresés..."
          value={searchQuery}
          onChange={(e) => onSearchChange?.(e.target.value)}
          autoFocus
          fullWidth
          size="small"
          sx={{ flex: 1 }}
        />
      </Box>

      {searchResults?.length === 0 ? (
        <Box>Nincs találat.</Box>
      ) : (
        <Box component="section" sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
          {searchResults?.map((evt, idx) => {
            const { simpleTaskId, simpleTaskName, startDate, endDate, simpleTaskDescription } = evt;

            return (
              <Box
                key={simpleTaskId}
                onClick={() => {
                  if (!Number.isNaN(simpleTaskId)) getTaskById(simpleTaskId);
                  handleClose();
                }}
                sx={{
                  px: 1.5,
                  py: 1,
                  border: '1px solid',
                  borderColor: 'divider',
                  borderRadius: 1,
                  cursor: 'pointer',
                  '&:hover': { bgcolor: 'action.hover' },
                }}
              >
                <Typography variant="subtitle1" fontWeight={600} sx={{ wordBreak: 'break-word' }}>
                  {simpleTaskName} #{simpleTaskId}
                </Typography>
                <Typography
                  variant="caption"
                  color="text.secondary"
                  component="div"
                  sx={{ display: 'block', mt: 0.25 }}
                >
                  <Box component="span" sx={{ fontWeight: 600 }}>
                    Kezdő dátum:
                  </Box>{' '}
                  {dayjs(startDate).format('YYYY-MM-DD')}
                </Typography>
                <Typography
                  variant="caption"
                  color="text.secondary"
                  component="div"
                  sx={{ display: 'block', mt: 0.25 }}
                >
                  <Box component="span" sx={{ fontWeight: 600 }}>
                    Befejező dátum:
                  </Box>{' '}
                  {dayjs(endDate).format('YYYY-MM-DD')}
                </Typography>
                <Typography
                  variant="caption"
                  color="text.secondary"
                  component="div"
                  sx={{ display: 'block', mt: 0.25 }}
                >
                  <Box component="span" sx={{ fontWeight: 600 }}>
                    Megj:
                  </Box>{' '}
                  {simpleTaskDescription}
                </Typography>
              </Box>
            );
          })}
        </Box>
      )}
    </DialogUI>
  );
};

export default SearchDialog;
